import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pw_enter",
  "use": "icon-pw_enter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pw_enter\"><defs><style>#icon-pw_enter .cls-1{fill:#afb7bc;}</style></defs><path class=\"cls-1\" d=\"M2.41184,13.40478H18.1821l-6.88978,6.88978a1.42307,1.42307,0,0,0,0,2.00481,1.406,1.406,0,0,0,1.99069,0l9.304-9.304a1.406,1.406,0,0,0,0-1.9907l-9.304-9.304a1.40763,1.40763,0,1,0-1.99069,1.9907L18.1821,10.5811H2.41184a1.41184,1.41184,0,0,0,0,2.82368Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol